export const enum UserRoleType {
  UNKNOWN = 0,
  EO = 1,
  TRADERRETAILER = 2,
  CUSTOMER = 3,
  MOBILECATERERS = 4,
}

export const enum ApplicationStatus {
  Approved = 0,
  Awaiting = 1,
  Rejected = 2,
  Withdraw = 3,
  InComplete = 4,
  Completed = 5,
}

export const enum EventActionType {
  MyEventView = "MyEventView",
  AddEditEvent = "AddEditEvent",
  ApplyApplication = "ApplyApplication",
  EoFinansialReport = "EoFinansialReport",
  TicketFinansialReports = "TicketFinansialReports",
  FeedBack = "FeedBack",
}

export const enum AccountActionType {
  PersonalProfile = "PersonalProfile",
  ManageSubscription = "ManageSubscription",
  BusinessProfile = "BusinessProfile",
  Payout = "Payout",
  Payments = "PayouPayments",
  ManageApplication = "ManageApplication",
  TraderReport = "TraderReports",
  ShopFront = "ShopFront",
  TraderUnits = "TraderUnits",
  Units = "Units",
  Notifications = "Notifications",
  Messages = "Messages",
  Reports = "Reports",
}

export const enum PaymentStatus {
  Unpaid = 0,
  PartiallyPaid = 1,
  Paid = 2,
  Canceled = 3,
}
export const enum EventStatus {
  Draft = 1,
  Published = 2,
  InProgress = 3,
  Completed = 4,
  Canceled = 5,
  Awaiting = 6,
  Rejected = 7,
}

export const enum TicketStatus {
  Redeem = 1,
  Active = 2,
  Cancel = 3,
}

export const enum ApplicationType {
  Fixed = 0,
  Tender = 1,
  Bid = 2,
  Turnover = 3,
}
